import React, { useEffect, useState } from 'react';
import { UseGlobelcourse } from './component/allcoursecontaxt/ALLCoursecontaxt';
import ReCAPTCHA from "react-google-recaptcha";
import { UseGlobellogin } from './component/Logincontaxt.jsx/Logincontex';
import { NavLink, useLocation } from "react-router-dom";
import { BASE_URL } from './Config/Config';
import { RECAPTCHA_SITE_KEY } from './component/GlobelHelper/GlobelRechpcha';

function Contactarea() {
  const {setsuccessfully} = UseGlobellogin();
  const {Allcourse} = UseGlobelcourse();
const [Enable, setEnable] = useState(true);
  const [formMessage, setFormMessage] = useState(''); // State to hold the success message
const [errors, setErrors] = useState({});
  const { hash } = useLocation();

   const getuniquedata = (data)=>{
    let newval = data.map((curelm)=>curelm.CourseMaster_courseCat.category_name);
           return [...new Set(newval)];
    }
  const categoryonlydata = getuniquedata( Allcourse)
 console.log(categoryonlydata);


  const [data, setData] = useState({
    name:"",
    mobile_number:"",
    email:"",
    subject:"",
    message:"",
    page_name:"Home Page"
  });


  function onChange(value) {
    console.log("Captcha value:", value);
    setEnable(false);
  }
  const handleInput = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setData({
      ...data,
      [name]: value
    });
  };
  const validateForm = () => {
    const fieldErrors = {};
    if (data.name.trim().length < 3) fieldErrors.name = 'Name must be at least 3 characters long.';
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) fieldErrors.email = 'Invalid email address.';
    if (!/^[0-9]{10}$/.test(data.mobile_number)) fieldErrors.mobile_number = 'Mobile number must be exactly 10 digits.';
    if (data.subject === '') fieldErrors.subject = 'Please select a subject.';
    if (data.message.trim() === '') fieldErrors.message = 'Message cannot be empty.';
    setErrors(fieldErrors);
    return Object.keys(fieldErrors).length === 0;
  };
  
 console.log(errors);
  const submitForm = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
         return;
    }
   try {
       const response =  await fetch(`${BASE_URL}/contactform/`,{
          method:"POST",
          headers:{'content-type': "application/json"},
          body:JSON.stringify(data),
        });

        const result = await response.json();
        console.log(result);
        if (response.ok) {
          setData({
            name: '',
            mobile_number: '',
            email: '',
            subject: '',
            message: '',
          });

            setsuccessfully(result.message);
            setTimeout(() => setsuccessfully(""), 5000);
      } 
      else {
        setFormMessage(result.message);
      }
   } catch (error) {
       setFormMessage({ error: "Unable to submit data. Please try again later." });
   }
  } ;
   useEffect(() => {
      if (hash) {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    }, [hash]);

  return (
    <>
      <div className="space-bottom" id="target-section">
        <div className="container">
        <div className="row">
            <div className="col-xl-6 mb-30 mb-xl-0">
              <div className="me-xxl-6 mt-60">
                <div className="title-area mb-25">
                  <h2 className="border-title h3">Have Any Questions?</h2>
                </div>
                <p className="mt-n2 mb-25">Have a inquiry or some feedback for us? Fill out the form <br /> below to contact our team.</p>
                <div>

                  <div className="contact-feature">
                  <NavLink to="https://www.google.com/maps" target="_blank" >
                    <div className="contact-feature-icon">
                      <i className="fal fa-location-dot" />
                    </div>
                    </NavLink>

                    <div className="media-body">
                      <p className="contact-feature_label">Our Address</p>
                      <NavLink to="https://www.google.com/maps"target="_blank"  className="contact-feature_link">11/90, Behind Girdhar Hospital,<br /> Malviya Nagar, Jaipur (Rajasthan) India-302017</NavLink>
                    </div>
                  </div>

                  <div className="contact-feature">
                     <NavLink to="tel:+919460548809"target="_blank">
                    <div className="contact-feature-icon">
                      <i className="fal fa-phone" />
                    </div>
                    </NavLink>
                    <div className="media-body">
                      <p className="contact-feature_label">Phone Number</p>
                      <NavLink to="tel:+919460548809"target="_blank" className="contact-feature_link"><span>+91 8094009100, +91 8094009188</span></NavLink>
                      {/* <a href="tel:+918094009188" class="contact-feature_link">Phone: <span>(+91) 8094009188</span></a> */}
                      <NavLink to="https://wa.me/919413561917" className="contact-feature_link">Whatsup: <span>, +91 9413561917</span></NavLink>
                    </div>
                  </div>

                  <div className="contact-feature">
                    <NavLink to="mailto:contact@auratechacademy.com"target="_blank" >
                    <div className="contact-feature-icon">
                      <i className="fal fa-envelope" />
                    </div>
                    </NavLink>
                    <div className="media-body">
                      <p className="contact-feature_label">Email</p>
                      <NavLink to="mailto:contact@auratechacademy.com"target="_blank" className="contact-feature_link"><span>contact@auratechacademy.com</span></NavLink>
                    </div>
                  </div>
                </div>
                <div className="contact-feature">
              <div className="contact-feature-icon">
                  <i className="fal fa-clock" />
             </div>
             <div className="media-body">
           <p className="contact-feature_label">Hours of Operation</p>
       <span className="contact-feature_link">Monday - Friday: 09:00 - 20:00</span>
    <span className="contact-feature_link">Sunday &amp; Saturday: 10:30 - 22:00</span>
  </div>
</div>
              </div>
            </div>
            <div className="col-xl-6">
              <div className="contact-form-wrap" data-bg-src="/assets/img/bg/contact_bg_1.png">
                <span className="sub-title">Contact With Us!</span>
                <h2 className="border-title">Get in Touch</h2>
                <form className="contact-form ajax-contact" onSubmit={submitForm}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control style-white"
                          name="name"
                          id="name"
                          onChange={handleInput}
                          value={data.name}
                          placeholder="Your Name*"
                          required
                        />
                        <i className="fal fa-user" />
                        {errors.name && (
                       <span style={{ color:'red'}}>{errors.name}</span>
                   )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="email"
                          className="form-control style-white"
                          name="email"
                          id="email"
                          onChange={handleInput}
                          value={data.email}
                          placeholder="Email Address*"
                          required
                        />
                        <i className="fal fa-envelope" />
                        {errors.email && (
                  <span style={{ color:'red'}}>{errors.email}</span>
                   )}
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <select
                          name="subject" 
                          id="subject"
                          className="single-select nice-select form-select style-white"
                          onChange={handleInput} 
                          value={data.subject} 
                          required
                        >
                          
                          <option value="" disabled hidden>
                            Select Subject*
                          </option>
                          {categoryonlydata.map((curdata , index)=>
                             <option key={index} value={curdata}>{curdata}</option>
                          )}
                        </select>
                     

                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <input
                          type="number"
                          className="form-control style-white"
                          name="mobile_number"
                          id="number"
                          value={data.mobile_number}
                          onChange={handleInput}
                          placeholder="Phone Number*"
                          required
                        />
                        <i className="fal fa-phone" />
                        {errors.mobile_number && (
                  <span style={{ color:'red'}}>{errors.mobile_number}</span>
                   )}
                      </div>
                    </div>
                    <div className="col-12">
                      <div className="form-group ">
                        <textarea
                          name="message"
                          id="message"
                          cols={30}
                          rows={3}
                          className="form-control style-white"
                          placeholder="Write Your Message*"
                          onChange={handleInput}
                          value={data.message}
                          required
                        />
                        <i className="fal fa-pen" />
                        {errors.message && (
                     <span style={{ color:'red'}}>{errors.message}</span>
                   )}
                      </div>
                    </div>
                 {formMessage && <div className="form-message" style={{color:"red",fontSize:"1.2rem", marginBottom:"12px"}}>{formMessage}</div>}       
                 <ReCAPTCHA
             sitekey={RECAPTCHA_SITE_KEY}
             onChange={onChange} style={{margin:"15px"}}
                />
                   
                    <div className="form-btn col-12 mt-10">
                      <button className="th-btn" disabled={Enable} style={Enable ?{opacity:'0.6'}:{opacity:''}}>
                        Send Message
                        <i className="fas fa-long-arrow-right ms-2" />
                      </button>
                    </div>
                  </div>
                  <p className="form-messages mb-0 mt-3" />
                </form>
              </div>
            </div>

          </div>

          <div className="map-sec mt-3">
            <div className="map">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14239.41072227147!2d75.8139627!3d26.8446376!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396db7aa5e84fe97%3A0xf6d3b00498c055af!2sAuratech%20Academy%20Software%20Training%20Institute!5e0!3m2!1sen!2sin!4v1717425626495!5m2!1sen!2sin"
                height={400}
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Contactarea;
